export const FILE_TYPES = {
  all: '*',
  excel:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  img: 'image/*',
};
